import { NotificationDialog } from './notification-dialog'

/**
 * SelfAdvisorConfirmDialog - asks the user to confirm an advisor invitation whose
 * email address matches the client fund owner (a donor acting as their own advisor).
 *
 * @param {boolean} open - Whether the dialog is open
 * @param {string} subject - What the advisor email matches, e.g. 'the client fund' or 'the logged in user'
 * @param {function} onBack - Called when the user goes back to edit the invitation
 * @param {function} onInvite - Called when the user confirms the invitation
 * @param {boolean} loading - Disables the actions while the invitation is being sent
 */
export function SelfAdvisorConfirmDialog({ open, subject, onBack, onInvite, loading = false }) {
  return (
    <NotificationDialog
      open={open}
      onClose={onBack}
      type="alert"
      title="Please Confirm"
      message={`BEWARE: The email address for this advisor is the same as ${subject}. Please confirm this is accurate.`}
      actions={[
        { label: 'Back', onClick: onBack, disabled: loading },
        { label: 'Invite', onClick: onInvite, disabled: loading },
      ]}
    />
  )
}
